import './App.css';

function App() {
  return (
    <div className="App">
      <h3>App component</h3>
    </div>
  );
}

export default App;
